export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="font-heading text-xl font-bold text-background-50 inline-block mb-3">
              每日爆料
            </span>
            <p className="text-sm text-background-300 leading-relaxed">
              国内领先的UGC爆料内容聚合平台，每日爆料大赛以赛事排名形式激励优质爆料创作。覆盖娱乐、科技、消费等20+领域，18万+活跃用户每天在这里发现真相、传播真相。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><a href="#cards" className="text-sm text-background-300 hover:text-primary-400 transition-colors">精选爆料</a></li>
              <li><a href="#updates" className="text-sm text-background-300 hover:text-primary-400 transition-colors">最新快讯</a></li>
              <li><a href="#ranking" className="text-sm text-background-300 hover:text-primary-400 transition-colors">爆料热榜</a></li>
              <li><a href="#topics" className="text-sm text-background-300 hover:text-primary-400 transition-colors">热门话题</a></li>
              <li><a href="#media" className="text-sm text-background-300 hover:text-primary-400 transition-colors">爆料视频</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">服务支持</h4>
            <ul className="space-y-2.5">
              <li><a href="#contact" className="text-sm text-background-300 hover:text-primary-400 transition-colors">爆料投稿</a></li>
              <li><a href="#faq" className="text-sm text-background-300 hover:text-primary-400 transition-colors">常见问题</a></li>
              <li><a href="#about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">关于我们</a></li>
              <li><span className="text-sm text-background-300">用户协议</span></li>
              <li><span className="text-sm text-background-300">隐私政策</span></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              暂无具体合作伙伴信息
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; 2024-2026 每日爆料 meiribaoliao.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">
              每日爆料大赛 | 爆料大赛排名 | 每日大赛入口
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}